import { siteInfo, stats } from "@/mocks/home";

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center justify-center overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `url(https://readdy.ai/api/search-image?query=Modern%20minimalist%20abstract%20geometric%20composition%20with%20soft%20warm%20gradients%20in%20cream%20and%20beige%20tones%2C%20clean%20flowing%20organic%20shapes%2C%20subtle%20golden%20accents%2C%20sophisticated%20corporate%20atmosphere%2C%20professional%20yet%20welcoming%2C%20no%20text%2C%20high%20quality%20digital%20art&width=1800&height=1000&seq=hero-bg-2026&orientation=landscape)`,
        }}
        role="img"
        aria-label="91.cn 品牌背景"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-black/10 to-black/30" />

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center">
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold text-white mb-6 leading-tight" style={{ fontFamily: "var(--font-heading)" }}>
          {siteInfo.tagline}
        </h1>
        <p className="text-base md:text-lg text-white/85 max-w-2xl mx-auto mb-10 leading-relaxed">
          {siteInfo.description}
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <button
            type="button"
            className="w-full sm:w-auto px-8 py-3.5 text-base font-medium whitespace-nowrap cursor-pointer rounded-md bg-primary-500 text-background-50 hover:bg-primary-600 transition-all duration-200"
          >
            立即开始使用
          </button>
          <button
            type="button"
            className="w-full sm:w-auto px-8 py-3.5 text-base font-medium whitespace-nowrap cursor-pointer rounded-md bg-white/15 text-white hover:bg-white/25 backdrop-blur-sm border border-white/30 transition-all duration-200"
          >
            了解更多
          </button>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6 mt-14">
          {stats.map((stat, index) => (
            <div key={index} className="bg-white/10 backdrop-blur-sm rounded-lg p-4 md:p-5 border border-white/15">
              <div className="text-2xl md:text-3xl font-bold text-white mb-1" style={{ fontFamily: "var(--font-heading)" }}>
                {stat.value}
              </div>
              <div className="text-xs md:text-sm text-white/70">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}